module.exports = __webpack_public_path__ + "img/flavor_pomegranate.1e940825.png";